import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
export default function IconText(props) {
    const { multiline, position, children, ...rest } = props;
    const icon = _jsx(FontAwesomeIcon, { ...rest });
    if (position === "right") {
        return (_jsxs("div", { className: "d-inline-flex gap-1 " + classnames({ "align-items-center": !multiline }), children: [_jsx("div", { children: children }), _jsx("div", { children: icon })] }));
    }
    return (_jsxs("div", { className: "d-inline-flex gap-1 " + classnames({ "align-items-center": !multiline }), children: [_jsx("div", { children: icon }), _jsx("div", { children: children })] }));
}
